import { render, staticRenderFns } from "./NotAcess.vue?vue&type=template&id=4e075ad6"
import script from "./NotAcess.vue?vue&type=script&lang=js"
export * from "./NotAcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports